import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PawningAccountDetailCard } from "./PawningAccountDetailCard";
import { useDispatch, useSelector } from "react-redux";
import {
  accountDetailsRequest,
  clearAccountDetails,
} from "../../../_redux/_actions/account.actions";
import { UiGrayBgLoader } from "../common/UiGrayBgLoader";

export const PawningAccountDetails = ({ accountNumber }) => {
  const { t } = useTranslation();
  const actionDispatch = useDispatch();

  const { accountDetail } = useSelector((state) => ({
    accountDetail: state.account?.accountDetails,
  }));

  // Fetch account details on initial load based on accountNumber prop
  useEffect(() => {
    if (accountNumber) {
      actionDispatch(accountDetailsRequest({ accountNo: accountNumber }));
    }
  }, [accountNumber]);

  useEffect(() => {
    return () => {
      actionDispatch(clearAccountDetails());
    };
  }, []);

  return (
    <>
      {accountDetail ? (
        <div className="df-acc-details-popup-cont">
          <h4 className="df-acc-details-popup-cont__title">
            {t("Pawning Account Details")}
          </h4>
          <PawningAccountDetailCard accountDetail={accountDetail} />
        </div>
      ) : (
        <UiGrayBgLoader className="df-ch-330" />
      )}
    </>
  );
};
